import contact from "./lib/contact";
import rebox from "./lib/rebox";
import { HistoryTimelineView } from "./lib/history-timeline.js";
import { toggleBelowFold, scrollSpy, smoothScroll } from "./lib/scroll";
import { Splide } from "@splidejs/splide";

(function () {
  "use strict";

  // NOTE: This way of detecting hover support is less than ideal.
  // Many devices support both touch and hover.
  var supportsTouch = typeof Touch === "object";
  var supportsHover = !supportsTouch;
  var isSmallDevice = window.matchMedia("(max-width: 992px)").matches;

  (function () {
    // Timeline
    $(document).ready(function () {
      window.historyTimelineView = new HistoryTimelineView({
        el: "#history-timeline",
      });
    });
  })();
})();

$(document).ready(function () {
  contact("#contact-form");
  rebox(".pump-image-thumb");
  toggleBelowFold();
  // scrollSpy('.header-nav-sub:visible', {offset: 0})
  // smoothScroll('a[href*="#"] ', {offset: 100})
});

document.addEventListener('DOMContentLoaded', function () {
  const mobileDropdowns = document.querySelectorAll('.dropdown-mobile')

  // 1. mobile-parent-link (innerer echter Link) darf nicht verhindern, darf aber kein Dropdown öffnen
  document.querySelectorAll('.mobile-parent-link a').forEach(function (link) {
    link.addEventListener('click', function (e) {
      e.stopPropagation() // Klick bleibt in der Ebene
    })
  })

  // 2. Dropdown öffnen/schließen
  mobileDropdowns.forEach(function (item) {
    // Der Klick soll NICHT hochwandern zu anderen dropdown-mobile
    item.addEventListener('click', function (e) {
      if (window.innerWidth >= 1200) return

      // Wenn ein echter Link im Dropdown geklickt wurde → Dropdown NICHT toggeln
      if (e.target.closest('a') && !e.target.closest('.level1-link')) {
        e.stopPropagation()
        return
      }

      // verhindern, dass der Klick Eltern-Dropdowns triggert
      e.stopPropagation()

      // Level-1-Link (der deaktivierte) soll nicht navigieren
      if (e.target.closest('.level1-link')) {
        e.preventDefault()
      }

      // Toggle nur auf diesem Element
      item.classList.toggle('open')
    })
  })

  // 3. body klick soll andere dropdowns NICHT schließen
  //    wir schließen nur, wenn du das willst – aktuell nicht nötig
})

document.addEventListener("DOMContentLoaded", function () {
  const elementInfo = document.querySelector(".job-area-slider");
  const elementIconSlider = document.querySelector(".icon-text-slider");

  if (elementIconSlider) {
    console.log("Element gefunden:", elementIconSlider);
    const splide = new Splide(".splide.icon-text", {
      perPage: 3,
      perMove: 3,
      gap: 20,
      mediaQuery: "max",
      breakpoints: {
        1024: {
          perPage: 1,
          perMove: 1,
          padding: "2rem",
          gap: 33,
        },
        500: {
          padding: "1rem",
        },
      },
    });
    splide.mount();
  } else {
    console.log('Kein Element mit der Klasse "icon-text-slider" gefunden.');
  }

  if (elementInfo) {
    console.log("Element gefunden:", elementInfo);
    const splide = new Splide(".splide.job-area", {
      perPage: 1,
      perMove: 1,
      gap: 35,
      padding: "1rem",
      mediaQuery: "min",
      breakpoints: {
        1200: {
          destroy: true,
        },
        500: {
          perPage: 2,
          perMove: 2,
          padding: "2.2rem",
          gap: 25,
        },
      },
    });
    splide.mount();
  } else {
    console.log('Kein Element mit der Klasse "job-area-slider" gefunden.');
  }
});

$(document).ready(function () {
  var selector = ".second-level-sub-navigation li";
  $(selector).on("click", function () {
    $(selector).removeClass("current");
    $(this).addClass("current");
  });
});

$(document).ready(function () {
  if ($(".second-level-sub-navigation").hasClass("visible-xs")) {
    $(".header").addClass("distance");
  }
});

$(window).scroll(function () {
  var position = window.pageYOffset;
  $(".grid-content").each(function () {
    var target = $(this).offset().top;
    var id = $(this).attr("id");
    var navLinks = $(".second-level-sub-navigation li a");
    var navLinksHome = $(".header-nav-list li a");
    if (position >= target - 220 && id) {
      navLinks.removeClass("active");
      navLinksHome.removeClass("active");
      $(
        '.second-level-sub-navigation li a[href*="#' + id + '"]'
      ).addClass("active");
      $('.header-nav-list li a[href*="#' + id + '"]').addClass("active");
      $(".second-level-sub-navigation li").removeClass("current");
    } else {
      $(".second-level-sub-navigation li current").addClass("current");
    }
  });
});

// close burger menu if cklcik on id to show target
$(".header-nav-list li a").click(function () {
  $(".header-nav-content").collapse("hide");
});

// $(document).ready(function () {
//     // Add smooth scrolling to all links
//     $(".header li a").on("click", function (event) {
//         if (this.hash !== "") {
//             var hash = this.hash;

//             $("html, body").animate(
//                 {
//                     scrollTop:
//                         $(hash).offset().top - $(".header").height() - 40,
//                 },
//                 500,
//                 function () {
//                     // window.location.hash = hash;
//                 }
//             );
//             return false;
//         }
//     });
// });

const triggerTabList = [].slice.call(
  document.querySelectorAll("#item-tab li:first-child .nav-link")
);
triggerTabList.forEach(function (triggerEl) {
  const tabTrigger = new bootstrap.Tab(triggerEl);

  triggerEl.addEventListener("click", function (event) {
    event.preventDefault();
    tabTrigger.show();
  });
});

$(".tab--wrapper .tab-content .tab-pane:first").addClass("show active");
$(".tab--wrapper #item-tab li .nav-link:first").addClass("active");

function initTabs() {
  // Finde alle Tab-Container auf der Seite
  const tabContainers = document.querySelectorAll(".tab--wrapper");

  // Iteriere durch alle Tab-Container
  tabContainers.forEach((tabContainer) => {
    // Finde die Tab-Links und Tab-Panes innerhalb des aktuellen Tab-Container
    const tabLinks = tabContainer.querySelectorAll(".nav-link");
    const tabContents = tabContainer.querySelectorAll(".tab-pane");

    // Füge einen Klick-Event-Listener zu allen Tab-Links in diesem Tab-Container hinzu
    tabLinks.forEach((tabLink, index) => {
      tabLink.addEventListener("click", function (e) {
        e.preventDefault();

        tabLinks.forEach((link) => {
          link.classList.remove("active");
        });

        this.classList.add("active");

        tabContents.forEach((content) => {
          content.classList.remove("show", "active");
        });

        tabContents[index].classList.add("show", "active");
      });
    });

    const firstTabLink = tabLinks[0];
    if (firstTabLink) {
      firstTabLink.click();
    }
  });
}
initTabs();

// Funktion zum ändern der Tab-Items nach URL Parameter

$(document).ready(function () {
  function processHashChange() {
    let tabContainerCounter = 1;

    function generateUniqueId() {
      return tabContainerCounter++;
    }

    const hash = window.location.hash;
    const hashParts = hash.substring(1).split("-");
    const containerId = hashParts[0];
    const tabPaneId = hashParts.slice(1).join("-");

    $(".tab--wrapper").each(function () {
      const uniqueId = generateUniqueId();
      $(this).addClass("tabContainer" + uniqueId);
      $(this).attr("id", "tabContainer" + uniqueId);
    });
    if (containerId) {
      $("." + containerId).each(function () {
        $("." + containerId + " .tab-pane").removeClass("show active");
        $("." + containerId + " #" + tabPaneId).addClass("show active");
        $("." + containerId + " .nav-link").removeClass("active");
        $(
          "." + containerId + ' .nav-link[href="#' + tabPaneId + '"]'
        ).addClass("active");
      });

      // Prüfen, ob sich das Container-Element bereits oben auf der Seite befindet
      if (
        $(window).scrollTop() !==
                $("." + containerId).offset().top - 200
      ) {
        const containerOffset = $("." + containerId).offset().top - 200;
        $("html, body").animate(
          {
            scrollTop: containerOffset,
          },
          500
        );
      }
    }
  }

  // Initialer Aufruf der Funktion zur Verarbeitung des Hash-Werts
  processHashChange();

  // Event-Listener für Änderungen des Hash-Werts der URL
  $(window).on("hashchange", function () {
    processHashChange();
  });
});

$(".carousel").carousel({
  interval: false,
});

$(window).scroll(function () {
  if ($(this).scrollTop() >= 600) {
    $(".back-to-top").fadeIn(300).addClass("visible");
  } else {
    $(".back-to-top").fadeOut(300).removeClass("visible");
  }
});

$(".back-to-top").click(function () {
  $("body,html").animate(
    {
      scrollTop: 0,
    },
    300
  );
});

$(document).ready(function () {
  $(".icon-group").on("click", function () {
    $(this).parent().toggleClass("active");
  });
});

$(document).ready(function () {
  $(".process-plan--item .close").on("click", function () {
    $(this).parent().removeClass("show");
    $(".overlay").removeClass("active");
  });
});
$(".content-group a").click(function () {
  const classClicked = $(this).attr("class");
  $(".neos-contentcollection .process-plan--item").removeClass("show");
  $(".item-" + classClicked).addClass("show");
  $(".item-0").removeClass("show");
  if ($(".neos-contentcollection .process-plan--item").hasClass("show")) {
    $(".overlay").addClass("active");
  } else {
    $(".overlay").removeClass("active");
  }
});

const closePopup = document.getElementById("overlay-wrapper");
if (closePopup) {
  closePopup.addEventListener("click", function () {
    $(".overlay").removeClass("active");
    $(".overlay .neos-contentcollection div").removeClass("show");
  });
}

// eslint-disable-next-line no-unexpected-multiline
const items = document.querySelectorAll(
  ".neos-contentcollection .time-line--item"
);

// check if an element is in viewport
// http://stackoverflow.com/questions/123999/how-to-tell-if-a-dom-element-is-visible-in-the-current-viewport
function isElementInViewport(el) {
  const rect = el.getBoundingClientRect();
  return (
    rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <=
            (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <=
            (window.innerWidth || document.documentElement.clientWidth)
  );
}

function callbackFunc() {
  for (let i = 0; i < items.length; i++) {
    if (isElementInViewport(items[i])) {
      items[i].classList.add("in-view");
    }
  }
}

// listen for events
window.addEventListener("load", callbackFunc);
window.addEventListener("resize", callbackFunc);
window.addEventListener("scroll", callbackFunc);

(function () {
  function setupInViewObserver() {
    const items = document.querySelectorAll(".time-line--item");
    if (!items.length) return;

    const io = new IntersectionObserver(
      (entries) =>
        entries.forEach((entry) => {
          // Einmalig aktivieren, nicht wieder entfernen
          if (entry.isIntersecting && !entry.target.classList.contains("in-view")) {
            entry.target.classList.add("in-view");
            // Danach unobserve, um nicht nochmal getriggert zu werden
            io.unobserve(entry.target);
          }
        }),
      { threshold: 0.15 }
    );

    items.forEach((el) => io.observe(el));
  }

  // Der Rest bleibt identisch (Timeline-Berechnung etc.)
  function buildTimeline() {
    const wrapper = document.querySelector(".time-line--wrapper");
    const axis = document.querySelector(".time-line--axis");
    const items = Array.from(document.querySelectorAll(".time-line--item"));
    if (!wrapper || !axis || !items.length) return;

    const vw = window.innerWidth;
    const isMobile = vw < 768;
    const isTablet = vw >= 768 && vw < 1200;

    const padTop = 20;
    const contentGap = isMobile ? 36 : isTablet ? 44 : 60;

    // --- 1️⃣ Datenbasis ---
    const years = items.map((it) => ({
      s: parseInt(it.dataset.attributesStartyear),
      e: it.dataset.attributesEndyear?.trim()
        ? parseInt(it.dataset.attributesEndyear)
        : parseInt(it.dataset.attributesStartyear) + 1,
      el: it,
    }));

    const minYear = Math.min(...years.map((y) => y.s));
    const maxYear = Math.max(...years.map((y) => y.e));
    const totalYears = maxYear - minYear;

    // --- 2️⃣ Inhaltsbedarf ---
    let totalContentHeight = 0;
    years.forEach((y) => {
      const teaser = y.el.querySelector(".teaser-section");
      const ch = teaser ? teaser.scrollHeight : 0;
      const span = Math.max(1, y.e - y.s);
      const minHeight = ch + contentGap;
      y.minHeight = minHeight;
      y.span = span;
      totalContentHeight += minHeight;
    });

    // --- 3️⃣ Dynamische Skala (px pro Jahr) ---
    const pxPerYear = Math.max(totalContentHeight / totalYears, 10);

    // --- 4️⃣ Positionierung ---
    let maxBottom = 0;
    years.forEach((y) => {
      const startOffset = (y.s - minYear) * pxPerYear;
      const yearHeight = Math.max(y.minHeight, y.span * pxPerYear);
      const item = y.el;

      item.style.position = "absolute";
      item.style.top = `${startOffset}px`;
      item.style.height = `${yearHeight}px`;
      item.style.margin = "0";
      item.style.padding = "0";

      const content = item.querySelector(".content");
      if (content) {
        content.style.position = "absolute";
        content.style.top = `${padTop}px`;
        content.style.left = "0";
        content.style.right = "0";
        content.style.bottom = `${padTop}px`;
        content.style.margin = "0";
        content.style.padding = "0";
      }

      maxBottom = Math.max(maxBottom, startOffset + yearHeight);
    });

    // --- 5️⃣ Zeitachse ---
    axis.innerHTML = "";
    const step = 10;
    for (let yr = minYear; yr <= maxYear; yr += step) {
      const label = document.createElement("div");
      label.className = "year";
      label.textContent = yr;
      label.style.position = "absolute";
      label.style.top = `${(yr - minYear) * pxPerYear}px`;
      axis.appendChild(label);
    }

    // --- 6️⃣ Wrapper-Höhe ---
    let sizer = wrapper.querySelector(".timeline-sizer");
    if (!sizer) {
      sizer = document.createElement("div");
      sizer.className = "timeline-sizer";
      wrapper.appendChild(sizer);
    }
    sizer.style.height = `${Math.ceil(maxBottom + 60)}px`;
  }

  // --- Resize + Init ---
  let resizeTimer;
  function onResize() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      buildTimeline();
      setupInViewObserver();
    }, 200);
  }

  document.addEventListener("DOMContentLoaded", () => {
    buildTimeline();
    setupInViewObserver();

    const imgs = document.querySelectorAll(".time-line--item img");
    let done = 0;
    const kick = () => {
      if (++done === imgs.length) buildTimeline();
    };
    imgs.forEach((img) => {
      if (img.complete) kick();
      else {
        img.addEventListener("load", kick, { once: true });
        img.addEventListener("error", kick, { once: true });
      }
    });
  });

  window.addEventListener("resize", onResize);
})();



document.addEventListener("DOMContentLoaded", () => {
  const targets = Array.from(document.querySelectorAll(".teaser--collection"));
  const OFFSET = 400; // Abstand vom oberen Viewport-Rand in px

  const check = () => {
    targets.forEach(el => {
      const rect = el.getBoundingClientRect();
      const distTop = rect.top;

      // Nur aktivieren, wenn der Viewport-Top maximal 100px vom Element entfernt ist
      if (distTop <= OFFSET && distTop >= -rect.height) {
        el.classList.add("active");
      }
    });
  };

  // Scroll-Optimierung
  let ticking = false;
  const onScroll = () => {
    if (!ticking) {
      requestAnimationFrame(() => {
        check();
        ticking = false;
      });
      ticking = true;
    }
  };

  window.addEventListener("scroll", onScroll, { passive: true });
  window.addEventListener("resize", onScroll, { passive: true });
  check(); // initialer Check (falls Element direkt im Sichtfeld)
});
